import { Pipe, PipeTransform } from '@angular/core';
import { getActivityAction } from './activity.functions';

@Pipe({
  name: 'activityAction'
})
export class ActivityActionPipe implements PipeTransform {
    transform(action?: string): string {
        return getActivityAction(action);
    }
};